import React, { useCallback } from 'react';
import { SortOption } from '../../../types';
import { Sorting } from '../Sorting';
import * as Styled from './MobileSort.styles';

type MobileSortProps = {
  open: boolean;
  onSort?: (sortItem: SortOption) => void;
  onClose: () => void;
};

const MobileSort = (props: MobileSortProps) => {
  const onSort = useCallback(
    (sortItem: SortOption) => {
      props.onSort?.(sortItem);
      props.onClose?.();
    },
    [props.onSort, props.onClose],
  );

  return (
    <Styled.SortDialog
      open={props.open}
      onClose={props.onClose}
      mobileFullscreen={true}
      showCloseIcon={true}
      title="Sort by"
    >
      <Sorting onSort={onSort} />
    </Styled.SortDialog>
  );
};

export default MobileSort;
